import React, { useState, useEffect } from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import Home from './components/Home';
import Webdesign from './components/Pages/Websitedesignpage/Webdesign';
import './App.css'; 
import Modal from '../src/components/Pages/Modal/Modal'; // Assuming you have created a Modal component

function App() {
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    // Automatically show modal after the page loads
    setTimeout(() => {
      setIsModalVisible(true);
    }, 1000); // Modal appears after 1 second
  }, []);

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/websitedesign" element={<Webdesign />}></Route>
        </Routes>
      </BrowserRouter>

      {/* Include the modal here */}
      <Modal show={isModalVisible} handleClose={handleCloseModal} />
    </>
  );
}

export default App;
